import { Controller } from "stimulus"
import "pickadate/lib/picker.date.js"
import translations from "../../translations"
import * as I18n from "../../services/i18n"

export default class extends Controller {
  static targets = ["startDateFrom", "startDateTo"]

  connect() {
    this.initializeDatepickers()
  }

  initializeDatepickers() {
    // Initialize datepickers for both date fields
    this.startDateFromTargets.forEach(target => {
      this.initializeDatepicker(target)
    })

    this.startDateToTargets.forEach(target => {
      this.initializeDatepicker(target)
    })
  }

  initializeDatepicker(target) {
    const trigger = target.querySelector('.pickadate')
    const input = target.querySelector('.mask-date-field')
    
    if (trigger && input && !$(trigger).data('pickadate')) {
      const $trigger = $(trigger)
      const $input = $(input)
      
      // Initialize the datepicker with custom options
      $trigger.pickadate({
        monthsFull: $('#translations').data("content").date.month_names.slice(1),
        monthsShort: $('#translations').data("content").date.abbr_month_names.slice(1),
        weekdaysFull: $('#translations').data("content").date.day_names,
        weekdaysShort: $('#translations').data("content").date.abbr_day_names,
        today: I18n.t(translations(), 'datepicker.hoje'),
        clear: I18n.t(translations(), 'datepicker.limpar'),
        close: I18n.t(translations(), 'datepicker.fechar'),
        format: 'dd/mm/yyyy',
        formatSubmit: 'yyyy/mm/dd',
        editable: false,
        container: 'body',
        onOpen: () => {
          const div_wrapper = $input.parent().find('div.special-field')
          div_wrapper.addClass('filled')
        },
        onClose: () => {
          $(document.activeElement).blur()
          const pickerValue = $trigger.pickadate('picker').get('select', 'dd/mm/yyyy')
          if (pickerValue) {
            $input.val(pickerValue)
          }
        },
        onClear: () => {
          $input.val('')
        }
      })
    }
  }

  // Clear all date fields when clear filters is clicked
  clearFilters() {
    // Clear start date from field
    this.startDateFromTargets.forEach(target => {
      this.clearDateField(target)
    })

    // Clear start date to field
    this.startDateToTargets.forEach(target => {
      this.clearDateField(target)
    })
  }

  clearDateField(target) {
    const input = target.querySelector('.mask-date-field')
    const trigger = target.querySelector('.pickadate')
    
    // Clear the input field
    if (input) {
      $(input).val('')
    }
    
    // Clear the datepicker if it exists
    if (trigger) {
      const picker = $(trigger).data('pickadate')
      if (picker) {
        picker.clear()
      }
    }
  }
} 